exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#create-tag-container {\n  display: inline-block; }\n\n#create-tag-text {\n  color: #32e37f;\n  font-size: 12px;\n  display: inline-block; }\n\n#create-tag-icon {\n  width: 11px;\n  height: 11px;\n  border-radius: 100%;\n  color: #32e37f;\n  font-size: small;\n  line-height: .65;\n  border: 1px solid #32e37f;\n  display: inline-block;\n  margin-left: 6px; }\n", ""]);

// exports
